export const vibrant = {
  100: "#D49AE8",
  200: "#BE88D1",
  300: "#A876BA",
  400: "#9263A3",
  500: "#7C518D",
  600: "#663F76",
  700: "#522E61",
  800: "#3B1B4A",
  900: "#260933",
};

export const neutral = {
  100: "#D9C4E1",
  200: "#C2AEC9",
  300: "#AA97B1",
  400: "#928199",
  500: "#7B6A82",
  600: "#65566C",
  700: "#4E3F54",
  800: "#36283C",
  900: "#1E1224",
  white: "#FFFFFF",
};

export const danger = {
  50: "#fbf1f1",
  100: "#f7e0e0",
  200: "#efc1c0",
  300: "#e9a1a0",
  400: "#e47e7c",
  500: "#e15451",
  600: "#c0423f",
  700: "#93302e",
  800: "#651f1d",
  900: "#3e0f0e",
  950: "#290807",
};

export const positive = {
  50: "#deffe1",
  100: "#b6ffbf",
  200: "#00ff59",
  300: "#00dc4b",
  400: "#00ba3e",
  500: "#009932",
  600: "#007926",
  700: "#005b1a",
  800: "#003e0f",
  900: "#002406",
  950: "#001803",
};
